import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Popconfirm, message } from "antd";
import { ReactNode } from "react";
import { useDeleteRootImpactReference } from "./useRootImpactReference";

export default function DeleteEpdAction({
  children,
  id,
  onSuccess,
}: {
  children: ReactNode;
  id?: number;
  onSuccess?: () => void;
}) {
  const deleteRootImpactReference = useDeleteRootImpactReference();
  const translation = useTranslation();
  const analytics = useAnalytics();

  return (
    <Popconfirm
      title={`Delete root impact reference`}
      description={
        <>
          <p>Deleting can cause the following:</p>
          <ul>
            <li>materials that use this root impact reference, need a new impact reference</li>
            <li>the impact calculation will be affected if there is a reference missing</li>
          </ul>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm={() =>
        deleteRootImpactReference
          .mutateAsync({ id })
          .then((result) => {
            if (result.status === 200) {
              message.success(`Root impact reference successfully removed.`);
              analytics.track("Root Impact Reference Deleted");
              onSuccess && onSuccess();
            }
          })
          .catch(() => message.error(translation.errors.general))
      }
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={`Delete`}
      cancelText="Cancel"
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: deleteRootImpactReference.isLoading }}
    >
      {children}
    </Popconfirm>
  );
}
